<template>
  <div class="menus-content">
    <div v-show="showMenus" class="mask">
      <div class="wrapper" @click.stop>
          <div class="block" >
            <div class="item-content">
              <van-radio-group v-model="radio">
                <van-cell-group>
                  <van-cell v-for="item in params" :title="item.name" clickable @click="changeRadio(item)" :key="item.id">
                    <template #right-icon>
                      <van-radio :name="item.name" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dropMenus',
  props: ['params', 'showMenus'],
  data () {
    return {
      radio: ''
    }
  },
  mounted () {
    console.log(this.params)
  },
  methods: {
    changeRadio (item) {
      this.$emit('parentData', item)
    },
    selected () {

    }
  }
}
</script>

<style scoped lang="scss">
    .menus-content{
      .mask{
        z-index: 1;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
      }
      .wrapper {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          height: 100%;
      }
      .block {
          width: 100%;
          height: 40%;
          background-color: #fff;
          overflow: scroll;
          padding-bottom: 20px;
        .item-content{
          height: auto;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/dropRadio.vue